import { useEffect, useState } from "react";
import DetailsPanelSkeleton from "./DetailsPanelSkeleton";
import appFetch from "../../appFetch";
import { appendQueryToUri, buildEditData, decodeHTML, encodeHTML, getSize } from "../../util/generalUtil";
import apiEndpoints from "../../apiEndpoints";
import AttachmentPreviewModal from "../AttachmentPreviewModal";
import TransactionLine from "../TransactionLine";
import { CheckIcon, ChevronLeft, Edit3Icon, XIcon } from "lucide-react";
import ActionButtons from "./ActionButtons";
import classNames from "classnames";
import StandaloneRichText from "../StandaloneRichText";
import OutlookReplyButton from "../OutlookReplyButton";
import { MailIcon } from "@heroicons/react/solid";
import WithLoader from "../WithLoader";
import moment from "moment";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import useMenuUpdate from "../../hooks/useMenuUpdate";
import { editorConfig } from "../ExtendedRichText";
import "../../styles/JoditScrollbar.css"


const MySwal = withReactContent(
  Swal.mixin({
    customClass: {
      confirmButton:
        "text-white font-medium rounded-lg text-sm px-5 py-2.5 text-center mr-2 mb-2 bg-primary",
      cancelButton:
        "text-white font-medium rounded-lg text-sm px-5 py-2.5 text-center mr-2 mb-2 bg-primary",
    },
    buttonsStyling: false,
  })
);

const DetailsPanel = ({ expense, isFullScreen, onToggleFullScreen, onClose, targetid, layoutid,setLoading:setPageLoading,setOptions:setEmailListOptions,menuId }) => {
  const [previewAttachment, setPreviewAttachment] = useState(null);
  const [isLoading, setLoading] = useState(false)
  const [options, setOptions] = useState(null)
  const [formContext, setFormContext] = useState(null);
  const [editorContent,setEditorContent] = useState("");
  const { updateMenu } = useMenuUpdate();
  
  // Edit subject state
  const [isEditingSubject, setIsEditingSubject] = useState(false);
  const [editedSubject, setEditedSubject] = useState('');

const updateSubject = (event) => {
  const value = event.target.value;
  setEditedSubject(value);
};

  useEffect(() => {
    setLoading(true)  
    setTransactionType()
  }, [expense.Drillid])

  const setTransactionType = (item) => {
    let data = {
      layoutId: layoutid,
      targetId: targetid,
      target: expense?.target?.toUpperCase(),
      targetType: expense?.target_type,
      drillId: expense?.Drillid
    };

    appFetch
      .get(appendQueryToUri(apiEndpoints.menuView, data))
      .then((result) => {
        const data = result.options[0]
        setOptions(data)

        const editContentDecoded = decodeHTML((data?.edit_content || [])[0]?.value ?? "")
        const editSubjectDecoded = decodeHTML((data?.edit_subject || [])[0]?.value ?? "")

        setEditorContent(editContentDecoded);
        setEditedSubject(editSubjectDecoded);
      })
      .catch((e) => console.log(e.message))
      .finally(() => setLoading(false));
  };

  const handleFormContextReady = (context) => {
    setFormContext(context);
  };

  const handleEditSubject = () => {
    setIsEditingSubject(true);
  };

  const handleSaveSubject = () => {
    // Here you would typically save to your backend
    console.log('Saving subject:', editedSubject);
    // For now, just exit edit mode
    setIsEditingSubject(false);
  };

  const handleCancelEdit = () => {
    setEditedSubject(editedSubject || '');
    setIsEditingSubject(false);
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      handleSaveSubject();
    } else if (e.key === 'Escape') {
      handleCancelEdit();
    }
  };

  if (isLoading || !options) {
    return <DetailsPanelSkeleton isFullScreen={isFullScreen} />;
  }

  let {
    line_header,
    line_data,
    attachment,
    line_control_edit,
    edit_header,
    email_header: headers,
    summary,
    target,
    button
  } = options;

  let lines = line_data ?? [];
  let header = (line_header || [])[0]?.name ?? [];
  let editable_controls = (line_control_edit || [])[0]?.name ?? [];
  let hasUpload = editable_controls?.find((m) => m.type == "upload");
  let hasDownload = editable_controls?.find((m) => m.type == "download");

  let headerControl = edit_header ?? [];
  header = header?.filter((str) => !/attachment/i.test(str));
  editable_controls = editable_controls?.filter(
    (row) => !/attachment/i.test(row?.column)
  );

  // const myAttachments = attachment?.reduce((a, b) => 
  //   a.concat(b?.name?.map(x => x.replace("http","https")))
  // , [])
  // .map((x, idx) => ({name: getFileNameFromUrl(x), url: x, id: idx}));

  const myAttachments = attachment?.reduce((a, b) => 
  a.concat(b?.line_attachment),[]);

  const handleAttachmentClick = (attachment) => {
    setPreviewAttachment(attachment);
  };

  const handleButtonClick = (button) => {
    const postData = {}

    const editContentModified = {...options.edit_content[0]}
    editContentModified[editContentModified.name] = encodeHTML(editorContent);
    const editSubjectModified = {...options.edit_subject[0]}
    editSubjectModified[editSubjectModified.name] = encodeHTML(editedSubject);

    // console.log('values from details panel', {
    //   button, 
    //   newValues,
    //   newEditableControls
    // })

    buildEditData(postData,edit_header[0])
    buildEditData(postData, editContentModified);
    buildEditData(postData, editSubjectModified);

    lines?.forEach((row) => {
      var data = {};
      for (let control of editable_controls) {
        let { name, type, response } = control;

        if (/label/i.test(type)) {
          continue;
        }

        let ref = data;
        let count = 1;
        let prop = "";
        while (true) {
          prop = control[`root_${count}`];

          //check if next exist
          if (typeof control[`root_${count + 1}`] == "undefined") break;

          ref[prop] = ref[prop] || {};
          ref = ref[prop];

          count++;
        }

        if (!prop) continue;
        let newName = `${name}_line_${row["LINE"]}`;

        let formValue = formContext.values[newName];

        if (type === "number") {
          formValue = formValue?.toString()?.replace(/,/g, "");
        }

        if (Array.isArray(formValue)) {
          if (formValue.length > 1) {
            formValue = formValue.map((m) => m?.value);
          } else {
            formValue = formValue[0]?.value ? [formValue[0].value] : [];
          }
        }

        if ({}.constructor === formValue?.constructor) {
          formValue = formValue?.value;
        }

        if (moment.isDate(formValue)) {
          formValue = moment(formValue).format("YYYY-MM-DD h:mmA");
        }

        formValue =
          response === "array"
            ? [].concat(formValue).filter((m) => m) // Ensure it's an array and filter out falsy values
            : formValue;

        console.log("let me check something", formValue, response);
        ref[prop] = formValue;
      }

      let lineProp = Object.keys(data).slice(-1)[0];

      if (lineProp) {
        data[lineProp]["LINE"] = row["LINE"];
        postData[lineProp] = (postData[lineProp] ?? []).concat(
          data[lineProp]
        );
      }
    });

    updateData(postData, button);
  }
  
  const updateData = (data, buttonAction) => {
      let postData = {
        jsonString: JSON.stringify([data]),
        menuId: menuId,
        pageButtonActionId: null,
        buttonAction: buttonAction.value,
      };

      setPageLoading(true)
      appFetch
        .post(apiEndpoints.menuAction, {
          body: JSON.stringify(postData),
        })
        .then((result) => {
          let { ERROR_MESSAGE: errMsg, ERROR_NUMBER: errNo } = result;

          MySwal.fire({
            text: errMsg,
            icon: errNo === 0 ? "success" : "error",
          }).then(() => {
            if(['approve','reject'].includes(buttonAction.name.toLowerCase())){
              onClose()
            }
          });

          if (errNo !== 0) {
            throw new Error(errMsg);
          }

          let emailListOptions = result?.layout.subcomponents[1]?.subcomponents[0]?.subcomponents[0]?.options;
          console.log('emailListOptions',{emailListOptions,btn:button.name})

          updateMenu(result?.MENU_BADGE);

          setEmailListOptions(emailListOptions)          
        })
        .catch((e) => console.log(e.message))
        .finally(() => setPageLoading(false));
  };

  if (!expense) return null;

  return (
    <>
        <div className={`bg-white border-l border-gray-200 h-screen ${isFullScreen ? 'fixed inset-0 z-40' : 'w-1/2'} flex flex-col`}>
          {/* Header */}
          <div className="p-6">
            <div className="flex justify-between items-center mb-2">
              <div className="flex items-center gap-2">
                <button
                  onClick={onClose}
                  className="border p-2 border-gray-300 rounded-md 300 p-2 text-gray-400 hover:text-gray-600 transition-colors"
                  title="Close"
                >
                 <ChevronLeft className="w-6 h-6" />
                </button>
                  <OutlookReplyButton
                    to={options?.edit_reply}
                    subject={editedSubject}
                    body={editorContent}
                  >
                    <span className="flex items-center gap-2 text-xs">
                      <MailIcon className="cw-6 h-6" />
                        Reply
                    </span>
                  </OutlookReplyButton>
              </div>
              <div className="flex items-center bg-gray-100 rounded p-1">

                  {/* Split screen button */}
                  <button
                    onClick={onToggleFullScreen}
                    className={`p-1 rounded transition-colors ${
                      !isFullScreen 
                        ? 'bg-primary text-white' 
                        : 'text-gray-400 hover:text-gray-600'
                    }`}
                    title="Split screen"
                  >
                    <svg className="w-10 h-6" fill="currentColor" viewBox="0 0 24 24">
                      <rect x="2" y="5" width="8" height="14" rx="1" />
                      <rect x="14" y="5" width="8" height="14" rx="1" />
                    </svg>
                  </button>
                  
                  {/* Fullscreen button */}
                  <button
                    onClick={onToggleFullScreen}
                    className={`p-1 rounded transition-colors ${
                      isFullScreen 
                        ? 'bg-primary text-white' 
                        : 'text-gray-400 hover:text-gray-600'
                    }`}
                    title="Fullscreen"
                  >
                    <svg className="w-10 h-6" fill="currentColor" viewBox="0 0 24 24">
                      <rect x="3" y="5" width="18" height="14" rx="1" />
                    </svg>
                  </button>
              </div>
            </div>

            <div className="border border-gray-300 rounded-md">
              <div className="bg-gray-100 flex items-center justify-between px-6 py-2 overflow-hidden rounded-md">
                <div className={classNames("flex items-center gap-2 min-w-0 mr-4",{"flex-1":isEditingSubject})}>
                  {isEditingSubject ? (
                    <div className="flex items-center gap-2 flex-1 min-w-0">
                      <input
                        type="text"
                        value={editedSubject}
                        onChange={updateSubject}
                        onKeyDown={handleKeyDown}
                        className="flex-1 text-lg font-semibold text-gray-900 bg-white border border-gray-300 rounded px-2 py-1 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent min-w-0"
                        autoFocus
                      />
                      <button
                        onClick={handleSaveSubject}
                        className="text-green-600 hover:text-green-700 transition-colors p-1"
                        title="Save"
                      >
                        <CheckIcon className="w-5 h-5" />
                      </button>
                      <button
                        onClick={handleCancelEdit}
                        className="text-gray-400 hover:text-gray-600 transition-colors p-1"
                        title="Cancel"
                      >
                        <XIcon className="w-5 h-5" />
                      </button>
                    </div>
                  ) : (
                    <>
                      <h2 className="text-lg font-semibold text-gray-900 truncate flex-1 min-w-0">
                        {editedSubject}
                      </h2>
                      <button
                        onClick={handleEditSubject}
                        className="text-primary hover:text-primary/80 transition-colors flex-shrink-0"
                        title="Edit subject"
                      >
                        <Edit3Icon className="w-5 h-5" />
                      </button>
                    </>
                  )}
                </div>

                {formContext && !isEditingSubject && (
                  <div className="flex gap-3 flex-shrink-0">
                    <ActionButtons 
                      buttons={button}
                      onButtonClick={handleButtonClick}
                    />
                  </div>
                )}
              </div>

              {/* Content with Custom Scrollbar */}
              <div className={`flex-1 overflow-y-auto p-6 scrollbar-thin scrollbar-thumb-gray-300 scrollbar-track-gray-100 hover:scrollbar-thumb-gray-400 scrollbar-thumb-rounded-full scrollbar-track-rounded-full max-h-[calc(100vh-100px)]`}>

                <div className="space-y-1">
                  {headers?.map(({ name, value }) => (
                    <div className="grid grid-cols-2 gap-4" key={name}>
                      <span className="text-sm font-medium text-gray-500">{name}</span>
                      <p className="text-sm text-gray-900">{value}</p>
                    </div>
                  ))}
                </div>

                {/* Attachments */}
                <div className="my-2">
                  <div className="flex gap-4 flex-wrap">
                    
                    {myAttachments?.map((attachment, idx) => (
                      <div
                        key={idx}
                        onClick={() => handleAttachmentClick(attachment)}
                        className="flex items-center gap-3 p-3 border border-gray-200 rounded-lg hover:bg-gray-50 cursor-pointer transition-colors"
                      >
                        <div className="flex-shrink-0">
                          <svg className="w-8 h-8 text-red-600" fill="currentColor" viewBox="0 0 24 24">
                            <path d="M14,2H6A2,2 0 0,0 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M18,20H6V4H13V9H18V20Z" />
                          </svg>
                        </div>
                        <div className="flex-1 min-w-0">
                          <p className="text-xs font-medium text-gray-900 truncate">{attachment.name}</p>
                          <p className="text-xs text-gray-500">{getSize(attachment.size)}</p>
                        </div>
                        <div className="flex-shrink-0">
                          <svg className="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                          </svg>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>

                <hr className="border-t border-gray-300 my-1" />

                {/* Expense Details */}
                <div className="space-y-1">
                  {summary?.map(({ name, value }) => (
                    <div className="grid grid-cols-2 gap-4" key={name}>
                      <span className="text-sm font-medium text-gray-500">{name}</span>
                      {name === 'Amount' ? (
                        <p className="text-sm font-medium text-gray-900" dangerouslySetInnerHTML={{ __html: value }}></p>
                      ) : (
                        <p className="text-sm text-gray-900">{value}</p>
                      )}
                    </div>)
                  )}
                </div>

                {/* TransactionLine */}
                <div className="my-4 border border-gray-100">
                   <TransactionLine
                          // Data props
                          header={header}
                          lines={lines}
                          editable_controls={editable_controls}
                          
                          // Configuration props
                          hasUpload={hasUpload}
                          hasDownload={hasDownload}
                          
                          // Form submission props
                          headerControl={headerControl}
                          item={options}
                          
                          // Layout props
                          layoutid={layoutid}
                          target={target}
                          targetid={targetid}
                          
                          // Form context callback
                          onFormContextReady={handleFormContextReady}
                          
                          // Additional props
                          // action={action}
                        />
                </div>

                {/* Memo Section */}
                <div className="mb-8">
                  <h3 className="text-sm font-medium text-gray-900 mb-3">Narration</h3>
                  <div className="border border-gray-200 rounded-lg">
                    {/* <ExtendedRichText /> */}
                     <StandaloneRichText
                      config={editorConfig}
                      name="description"
                      label="Description"
                      value={editorContent}
                      onChange={setEditorContent}
                      validation={{ required: true }}
                      indent="yes"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      <AttachmentPreviewModal
        isOpen={!!previewAttachment}
        onClose={() => setPreviewAttachment(null)}
        attachment={previewAttachment}
      />
    </>
  );
};

export default WithLoader(DetailsPanel);